import { range, reduce } from 'ramda'

import { AccrualCompensation } from 'app/dataTypes/subsidy/settings'
import { isCommonAllowance } from 'app/dataTypes/subsidy/allowances'

import { controls, selection } from './formParts/accrualFormCompensationControls'


const defaultAccrual: AccrualCompensation = {
  num: 0,
  active: false,
  complexes: [],
  sum: '',
  sum1_4: '',
  sum5_11: '',
  type: 'complexes',
  forCertainComplexes: false
}

export function extractCompensationAccruals(formData: FormData, accrualsShiftsAmount: number): Array<AccrualCompensation> {
  const allowanceID = formData.get('allowanceID') as string
  if (!allowanceID) throw new Error('Нужен параметр allowanceID в formData (extractAccruals)')
  const common = isCommonAllowance(allowanceID)

  return reduce((acc, value) => {
    const num = value + 1
    const active = formData.get(`${controls.activeCheckbox}${num}`)
    const complexes = formData.getAll(`${controls.complexesList}${num}`) as (Array<string> | undefined)
    const complexesIDs = complexes ? complexes.map(key => ({ ID: key })) : []
    const currentSelection = formData.get(`${controls.selectionRadio}${num}`)

    if (active) {
      if (common) {
        if (currentSelection === selection.chosen_complex) {
          acc.push({
            ...defaultAccrual,
            num,
            active: true,
            complexes: complexesIDs,
          })
          return acc
        }
        acc.push({
          ...defaultAccrual,
          num,
          active: true,
          complexes: complexesIDs,
        })
        return acc
      }

      if (currentSelection === selection.complexes) {
        acc.push({ ...defaultAccrual, num, active: true, complexes: complexesIDs })
        return acc
      }

      if (currentSelection === selection.sum) {
        const currentSum = (formData.get(`${controls.sumInput}${num}`) as string | undefined) || ''
        const sumForComplexes = formData.get(`${controls.sumForComplexesCheckbox}${num}`)
        if (currentSum) {
          if (!sumForComplexes) {
            acc.push({ ...defaultAccrual, num, active: true, sum: currentSum })
            return acc
          }
          if (sumForComplexes) {
            acc.push({ ...defaultAccrual, num, active: true, sum: currentSum, complexes: complexesIDs })
            return acc
          }
        }
      }

    }
    acc.push({ ...defaultAccrual, num })
    return acc
  }, [] as Array<AccrualCompensation>, range(0, accrualsShiftsAmount))
}
